import { gql } from '@apollo/client'

export const IMAGE_FRAGMENT = gql`
  fragment Image on Image {
    id
    url
    created
    modified
    type
    width
    height
    orientation
    isThumbnail
    isPrimary
    uploadedToGcsOn
    bucketFileName
    saved
  }
`
